/* ============================================================
   Galaxy Gaming — homepage behavior
   - reveal-on-scroll + mobile tab-bar tracking
   - passes configurator (switch real products) -> native cart drawer
   - generic Add-to-Bag (membership / PCs / gift cards) -> native cart drawer
   - party booking sheet wired to the REAL app proxy:
       GET  /apps/booking/api/availability
       POST /apps/booking/api/booking  -> redirect to Shopify checkout
   Loaded once on the index template from layout/theme.liquid.
   ============================================================ */
(function () {
  'use strict';
  document.documentElement.classList.add('gg-js');

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var PROXY = (window.ggHome && window.ggHome.proxyBase) || '/apps/booking';

  function money(cents) {
    var n = (cents || 0) / 100;
    return '$' + (Math.round(n * 100) / 100).toFixed(2).replace(/\.00$/, '');
  }
  function moneyFromDollars(v) { return '$' + Number(v).toFixed(2).replace(/\.00$/, ''); }

  /* ---------- island toast ---------- */
  var islandEl, islandTimer = null, pinned = null;
  function island() { islandEl = islandEl || $('#gg-island'); return islandEl; }
  function showIsland(em, html) {
    var el = island(); if (!el) return;
    el.querySelector('.em').textContent = em || '';
    el.querySelector('.msg').innerHTML = html || '';
    el.classList.add('show');
  }
  function toast(em, msg) {
    var el = island(); if (!el) return;
    clearTimeout(islandTimer);
    showIsland(em, String(msg).replace(/</g, '&lt;'));
    islandTimer = setTimeout(function () {
      if (pinned) pinned.render(); else el.classList.remove('show');
    }, 2200);
  }

  /* ---------- native cart drawer add ---------- */
  function cartDrawer() { return document.querySelector('cart-drawer'); }
  function addToCart(variantId, qty, name) {
    var id = Number(variantId);
    if (!id) { toast('⚠️', 'This item isn’t available yet'); return Promise.reject(); }
    var drawer = cartDrawer();
    var body = { items: [{ id: id, quantity: qty || 1 }] };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          toast('⚠️', res.description || res.message || 'Could not add to cart');
          throw new Error(res.description || 'add failed');
        }
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(res);
        } else {
          toast('🛒', (name || 'Item') + ' added to cart');
          if (window.routes) window.location.href = window.routes.cart_url || '/cart';
        }
        return res;
      });
  }

  /* ---------- generic Add-to-Bag buttons ---------- */
  function bindAddButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-gg-add]');
      if (!btn) return;
      e.preventDefault();
      var vid = btn.getAttribute('data-variant-id');
      var qty = parseInt(btn.getAttribute('data-qty') || '1', 10);
      var name = btn.getAttribute('data-name') || 'Item';
      btn.setAttribute('aria-busy', 'true');
      addToCart(vid, qty, name).catch(function () {}).then(function () {
        btn.removeAttribute('aria-busy');
      });
    });
  }

  /* ---------- passes configurator ---------- */
  function initConfig(cfg) {
    var segWrap = $('.gg-seg', cfg);
    var btns = $$('button[data-idx]', segWrap);
    if (!btns.length) return;
    var thumb = $('.thumb', segWrap);
    var priceEl = $('.gg-tk-price', cfg);
    var descEl = $('.gg-tk-desc', cfg);
    var flagEl = $('.gg-tk-flag', cfg);
    var qtyEl = $('.gg-tk-qty', cfg);
    var addBtn = $('.gg-tk-add', cfg);
    var idx = parseInt(cfg.getAttribute('data-default') || '0', 10);
    var qty = 1;
    var n = btns.length;

    segWrap.style.gridTemplateColumns = 'repeat(' + n + ',1fr)';
    if (thumb) thumb.style.width = 'calc((100% - 4px)/' + n + ')';

    function current() { return btns[idx]; }
    function priceCents() { return parseInt(current().getAttribute('data-price-cents') || '0', 10); }

    function render() {
      if (thumb) thumb.style.transform = 'translateX(calc(' + idx + ' * 100%))';
      btns.forEach(function (b, i) { b.setAttribute('aria-pressed', i === idx ? 'true' : 'false'); });
      var p = (priceCents() / 100).toFixed(2).split('.');
      if (priceEl) priceEl.innerHTML = '$' + p[0] + '<small>.' + p[1] + '</small>';
      if (descEl) descEl.textContent = current().getAttribute('data-desc') || '';
      if (flagEl) {
        var flag = current().getAttribute('data-flag');
        flagEl.style.display = flag ? '' : 'none';
        if (flag) flagEl.textContent = flag;
      }
      if (qtyEl) qtyEl.textContent = qty;
      if (addBtn) addBtn.textContent = 'Add to Bag · ' + money(priceCents() * qty);
    }

    segWrap.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-idx]');
      if (!b) return;
      idx = parseInt(b.getAttribute('data-idx'), 10);
      render();
    });
    $$('[data-gg-step]', cfg).forEach(function (s) {
      s.addEventListener('click', function () {
        var dir = s.getAttribute('data-gg-step');
        if (dir === 'inc' && qty < 20) qty++;
        if (dir === 'dec' && qty > 1) qty--;
        render();
      });
    });
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var vid = current().getAttribute('data-variant-id');
        var name = current().getAttribute('data-name') || 'Pass';
        addBtn.setAttribute('aria-busy', 'true');
        addToCart(vid, qty, name).catch(function () {}).then(function () {
          addBtn.removeAttribute('aria-busy');
          qty = 1; render();
        });
      });
    }
    render();
  }

  /* ---------- parties activity switcher ---------- */
  function initSwitchers() {
    $$('[data-gg-switcher]').forEach(function (sw) {
      var buttons = $$('button[data-group]', sw);
      var scope = sw.closest('[data-gg-parties]') || document;
      buttons.forEach(function (b) {
        b.addEventListener('click', function () {
          var g = b.getAttribute('data-group');
          buttons.forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
          $$('[data-group-panel]', scope).forEach(function (panel) {
            panel.hidden = panel.getAttribute('data-group-panel') !== g;
          });
        });
      });
    });
  }

  /* ============================================================
     PARTY BOOKING SHEET (real availability + booking API)
     ============================================================ */
  var sheet, overlay, sheetBody, sheetTitle;
  var bk = null;         // active booking state
  var holdTick = null;

  function ensureSheetRefs() {
    sheet = sheet || $('#gg-booking-sheet');
    overlay = overlay || $('#gg-overlay');
    if (sheet) { sheetBody = $('.sheet-body', sheet); sheetTitle = $('#gg-bk-title', sheet); }
    return !!sheet;
  }

  function openSheet() {
    if (!ensureSheetRefs()) return;
    overlay.classList.add('open');
    sheet.classList.add('open');
    document.body.classList.add('gg-scroll-lock');
  }
  function closeSheet() {
    if (!sheet) return;
    sheet.classList.remove('open');
    overlay.classList.remove('open');
    document.body.classList.remove('gg-scroll-lock');
    stopHold();
  }

  function iso(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }
  function startOfToday() { var d = new Date(); d.setHours(0, 0, 0, 0); return d; }

  function openBooking(trigger) {
    if (!ensureSheetRefs()) {
      // no sheet on page — fall back to the product page
      var url = trigger.getAttribute('data-product-url');
      if (url) window.location.href = url;
      return;
    }
    bk = {
      productId: trigger.getAttribute('data-product-id'),
      productUrl: trigger.getAttribute('data-product-url') || '#',
      title: trigger.getAttribute('data-title') || 'Book a party',
      emoji: trigger.getAttribute('data-emoji') || '🎉',
      bg: trigger.getAttribute('data-bg') || 'g-a',
      view: 'date',
      monthOffset: 0,
      dateISO: null,
      slot: null,
      slots: [],
      pkg: null,
      guests: 0,
      loading: false,
      error: null
    };
    openSheet();
    render();
    // preload package meta for today's month
    fetchAvailability(iso(startOfToday()), true);
  }

  function fetchAvailability(dateStr, metaOnly) {
    bk.loading = true; bk.error = null;
    if (!metaOnly) render();
    fetch(PROXY + '/api/availability?productId=' + encodeURIComponent(bk.productId) + '&date=' + dateStr)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        bk.loading = false;
        if (data.error) { bk.error = data.error; bk.slots = []; render(); return; }
        if (data.requiresScheduling === false) {
          bk.quoteOnly = true; bk.quoteMsg = data.message; render(); return;
        }
        bk.pkg = data.package || bk.pkg;
        bk.upsells = data.upsells || [];
        if (bk.pkg && bk.guests === 0) bk.guests = bk.pkg.includedGuests;
        if (!metaOnly) { bk.slots = data.slots || []; }
        render();
      })
      .catch(function () { bk.loading = false; bk.error = 'Failed to load availability. Please try again.'; render(); });
  }

  function calcTotalCents() {
    if (!bk.pkg) return 0;
    var extra = Math.max(0, bk.guests - bk.pkg.includedGuests);
    return bk.pkg.priceCents + extra * bk.pkg.extraGuestPriceCents;
  }
  function depositCents() {
    if (!bk.pkg) return 0;
    var total = calcTotalCents();
    var amt = 0;
    if (bk.pkg.depositType === 'fixed') amt = bk.pkg.depositValue || 0;
    else if (bk.pkg.depositType === 'percent') amt = Math.round((total * (bk.pkg.depositValue || 0)) / 100);
    return amt > 0 && amt < total ? amt : 0;
  }

  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
  function glyph(id) {
    var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg'); s.setAttribute('class', 'gl');
    var u = document.createElementNS('http://www.w3.org/2000/svg', 'use'); u.setAttribute('href', '#' + id); s.appendChild(u); return s;
  }

  function render() {
    if (!bk || !sheetBody) return;
    sheetTitle.textContent = bk.title;
    sheetBody.innerHTML = '';

    // package line
    var line = el('div', 'bk-pkg-line');
    var ic = el('div', 'ic ' + bk.bg, bk.emoji);
    var t = el('div', 't');
    if (bk.pkg) {
      t.appendChild(el('b', null, bk.pkg.name));
      var sub = 'Up to ' + bk.pkg.maxGuests + ' guests';
      var dep = depositCents();
      if (dep > 0) sub += ' · ' + money(dep) + ' deposit holds it';
      t.appendChild(el('small', null, sub));
    } else {
      t.appendChild(el('b', null, bk.title));
      t.appendChild(el('small', null, 'Pick a date to see live times'));
    }
    line.appendChild(ic); line.appendChild(t);
    sheetBody.appendChild(line);

    if (bk.quoteOnly) {
      var q = el('p', 'reassure', bk.quoteMsg || 'This package is booked by request.');
      sheetBody.appendChild(q);
      var go = el('a', 'gg-cta'); go.href = bk.productUrl; go.textContent = 'View package';
      go.style.marginTop = '14px'; go.style.display = 'flex';
      sheetBody.appendChild(go);
      return;
    }

    renderCalendar();
    if (bk.dateISO) renderSlots();
    if (bk.slot) renderGuestsAndSummary();

    if (bk.error) { sheetBody.appendChild(el('div', 'bk-error', bk.error)); }
  }

  function renderCalendar() {
    sheetBody.appendChild(el('div', 'bk-step-label', '1 · Pick your date'));
    var base = startOfToday();
    var m = new Date(base.getFullYear(), base.getMonth() + bk.monthOffset, 1);

    var head = el('div', 'cal-head');
    head.appendChild(el('b', null, m.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })));
    var nav = el('div', 'cal-nav');
    var prev = el('button', 'gg-press'); prev.setAttribute('aria-label', 'Previous month'); prev.appendChild(glyph('i-chev-l'));
    var next = el('button', 'gg-press'); next.setAttribute('aria-label', 'Next month'); next.appendChild(glyph('i-chev'));
    prev.disabled = bk.monthOffset === 0;
    next.disabled = bk.monthOffset >= 2;
    prev.addEventListener('click', function () { if (bk.monthOffset > 0) { bk.monthOffset--; render(); } });
    next.addEventListener('click', function () { if (bk.monthOffset < 2) { bk.monthOffset++; render(); } });
    nav.appendChild(prev); nav.appendChild(next);
    head.appendChild(nav);
    sheetBody.appendChild(head);

    var grid = el('div', 'cal-grid');
    ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].forEach(function (d) { grid.appendChild(el('div', 'dow', d)); });
    var startDay = m.getDay();
    var days = new Date(m.getFullYear(), m.getMonth() + 1, 0).getDate();
    for (var d = 1; d <= days; d++) {
      var date = new Date(m.getFullYear(), m.getMonth(), d);
      var dISO = iso(date);
      var b = el('button', 'cal-day gg-press', String(d));
      b.setAttribute('data-date', dISO);
      if (d === 1) b.style.gridColumnStart = startDay + 1; // avoid collapsed empty cells
      if (date < base) b.disabled = true;
      if (dISO === bk.dateISO) b.classList.add('sel');
      grid.appendChild(b);
    }
    grid.addEventListener('click', function (e) {
      var b = e.target.closest('.cal-day'); if (!b || b.disabled) return;
      bk.dateISO = b.getAttribute('data-date'); bk.slot = null;
      fetchAvailability(bk.dateISO);
    });
    sheetBody.appendChild(grid);
  }

  function renderSlots() {
    sheetBody.appendChild(el('div', 'bk-step-label', '2 · Pick a time'));
    if (bk.loading) { sheetBody.appendChild(el('div', 'bk-loading', 'Loading times…')); return; }
    if (!bk.slots.length) {
      sheetBody.appendChild(el('p', 'reassure', 'No open times that day — try another date.'));
      return;
    }
    var grid = el('div', 'slot-grid');
    bk.slots.forEach(function (s) {
      var b = el('button', 'slot gg-press');
      b.appendChild(el('b', null, s.startTime));
      b.appendChild(el('small', null, s.endTime ? 'ends ' + s.endTime : 'Open'));
      if (bk.slot && bk.slot.startISO === s.startISO) b.classList.add('sel');
      b.addEventListener('click', function () { bk.slot = s; render(); });
      grid.appendChild(b);
    });
    sheetBody.appendChild(grid);
  }

  function renderGuestsAndSummary() {
    var pkg = bk.pkg; if (!pkg) return;
    sheetBody.appendChild(el('div', 'bk-step-label', '3 · How many guests?'));
    var jr = el('div', 'jump-row');
    var jt = el('div', 't');
    jt.appendChild(el('b', null, bk.guests + ' guests'));
    var hint = 'Includes up to ' + pkg.includedGuests;
    if (pkg.extraGuestPriceCents > 0) hint += ' — extras ' + money(pkg.extraGuestPriceCents) + ' each';
    jt.appendChild(el('small', null, hint));
    var st = el('div', 'gg-stepper');
    var dec = el('button', 'gg-press', '−'); dec.setAttribute('aria-label', 'Fewer guests');
    var qs = el('span', null, String(bk.guests));
    var inc = el('button', 'gg-press', '+'); inc.setAttribute('aria-label', 'More guests');
    dec.addEventListener('click', function () { if (bk.guests > 1) { bk.guests--; render(); } });
    inc.addEventListener('click', function () { if (bk.guests < pkg.maxGuests) { bk.guests++; render(); } });
    st.appendChild(dec); st.appendChild(qs); st.appendChild(inc);
    jr.appendChild(jt); jr.appendChild(st);
    sheetBody.appendChild(jr);

    var total = calcTotalCents();
    var dep = depositCents();
    var extra = Math.max(0, bk.guests - pkg.includedGuests);
    var sum = el('div', 'bk-summary');
    sum.appendChild(row(pkg.name, money(pkg.priceCents)));
    if (extra > 0) sum.appendChild(row(extra + ' extra guest' + (extra > 1 ? 's' : ''), money(extra * pkg.extraGuestPriceCents)));
    sum.appendChild(row('Party total', money(total), 'total'));
    if (dep > 0) {
      sum.appendChild(row('Due today (deposit)', money(dep), 'due'));
      sum.appendChild(row('At the party', money(total - dep)));
    }
    sheetBody.appendChild(sum);

    var cta = el('button', 'gg-cta gg-press');
    cta.style.marginTop = '14px';
    if (bk.loading) { cta.textContent = 'Reserving…'; cta.disabled = true; }
    else {
      cta.appendChild(glyph('i-lock'));
      cta.appendChild(document.createTextNode(dep > 0 ? 'Pay ' + money(dep) + ' deposit & reserve' : 'Reserve & checkout'));
    }
    cta.addEventListener('click', submitBooking);
    sheetBody.appendChild(cta);
    sheetBody.appendChild(el('p', 'reassure', 'Your slot is held for ' + (pkg.holdMinutes || 10) + ' minutes while you check out.'));
  }

  function row(label, val, cls) {
    var r = el('div', 'row' + (cls ? ' ' + cls : ''));
    r.appendChild(el('span', null, label));
    r.appendChild(el('b', null, val));
    return r;
  }

  function submitBooking() {
    if (!bk.slot || !bk.pkg) return;
    bk.loading = true; bk.error = null; render();
    fetch(PROXY + '/api/booking', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        packageId: bk.pkg.id,
        shopifyProductId: bk.productId,
        guestCount: bk.guests,
        startTime: bk.slot.startISO
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.error) { bk.error = data.error; bk.loading = false; render(); return; }
        if (data.booking && data.booking.invoiceUrl) {
          toast('🔒', 'Opening secure checkout…');
          window.location.href = data.booking.invoiceUrl;
        } else {
          bk.error = 'Could not create checkout. Please try again.'; bk.loading = false; render();
        }
      })
      .catch(function () { bk.error = 'Failed to reserve. Please try again.'; bk.loading = false; render(); });
  }
  function stopHold() { if (holdTick) { clearInterval(holdTick); holdTick = null; } }

  function bindSheet() {
    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-gg-book]');
      if (open) { e.preventDefault(); openBooking(open); return; }
      if (e.target.closest('[data-gg-close]')) { closeSheet(); return; }
    });
    if (ensureSheetRefs() && overlay) overlay.addEventListener('click', closeSheet);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
  }

  /* ---------- reveal + tab bar ---------- */
  function initReveal() {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    $$('.gg-reveal').forEach(function (n) { io.observe(n); });
  }
  function initTabbar() {
    var tabs = $$('.gg-tabbar .tab'); if (!tabs.length) return;
    document.body.classList.add('gg-has-tabbar');
    var ids = tabs.map(function (t) { return t.getAttribute('data-sec'); }).filter(Boolean);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        tabs.forEach(function (t) { t.classList.toggle('active', t.getAttribute('data-sec') === en.target.id); });
      });
    }, { rootMargin: '-40% 0px -55% 0px' });
    ids.forEach(function (id) { var s = document.getElementById(id); if (s) io.observe(s); });
  }

  function init() {
    bindAddButtons();
    bindSheet();
    initSwitchers();
    initReveal();
    initTabbar();
    $$('.gg-config').forEach(initConfig);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
